<template>
    <div v-show="is_show_filter_preiod" class="works-filter__block works-filter__block-period">
        <div :class="title_class">{{ $t("message.Period") }}</div>
        <div class="period-range">
            <div class="item-cell">
              <input type="" onkeypress="return is_input_digits(event)"
                     v-model.number="year_from"
                     v-on:blur="set_year_from(year_from_in)" v-on:keyup.enter="set_year_from(year_from_in)"
                     name="" :placeholder="$t('message.YearFrom')" class="ref-input ref-input-md">
            </div>
            <div class="item-cell">
              <input type="" onkeypress="return is_input_digits(event)"
                     v-model.number="year_to"
                     v-on:blur="set_year_to(year_to_in)" v-on:keyup.enter="set_year_to(year_to_in)"
                     name="" :placeholder="$t('message.YearBefore')" class="ref-input ref-input-md">
            </div>
        </div>
        <div v-if="min_from<period_min" class="item-line"><label :class="label_class"><span class="checkbox"><input type="checkbox" name="" v-model="less1950" @change="periodChange('less1950')"><span class="check"></span></span> {{ label_less1950 }}</label></div>
        <div class="item-line"><label :class="label_class"><span class="checkbox"><input type="checkbox" name="" v-model="from1950to1990" @change="periodChange('from1950to1990')"><span class="check"></span></span> {{ label_from1950to1990 }}</label></div>
        <div v-if="max_to>period_max" class="item-line"><label :class="label_class"><span class="checkbox"><input type="checkbox" name="" v-model="more1990" @change="periodChange('more1990')"><span class="check"></span></span> {{ label_more1990 }}</label></div>
    </div>
</template>


<script>
  import FilterPeriodMix from "./FilterPeriodMix";

  export default {
    name      : 'filter-period',
    props:{
      title_class: {type: String, default:'works-filter__block-title'},
      label_class: {type: String, default:''},
    },
    mixins: [FilterPeriodMix],
  }
</script>



// WEBPACK FOOTER //
// src/components/list/filter/FilterPeriod.vue